import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=5a37d87e&scoped=true"
import script from "./Pesquisa.vue?vue&type=script&lang=js"
export * from "./Pesquisa.vue?vue&type=script&lang=js"
import style0 from "./Pesquisa.vue?vue&type=style&index=0&id=5a37d87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37d87e",
  null
  
)

export default component.exports